export const fileUploadSize = 12 * 1024 * 1024; // 12 MB